/** Port von `Services/LocalStorage.cs`, beschränkt auf den Schlüssel `currentApp`. */

import { CURRENT_APP_STORAGE_KEY } from '@/config/appConfig';
import type { App } from '@/types/entities';

/** Pendant zu `LocalStorage.GetAsync<App>("currentApp")`. */
export function readStoredCurrentApp(): App | null {
  const stored = window.localStorage.getItem(CURRENT_APP_STORAGE_KEY);
  if (stored === null) {
    return null;
  }

  try {
    return (JSON.parse(stored) as App | null) ?? null;
  } catch {
    return null;
  }
}

/**
 * Pendant zu `LocalStorage.SetAsync("currentApp", app)`. `null` schreibt — wie im Altclient —
 * den JSON-Wert `null`, statt den Schlüssel zu entfernen.
 */
export function writeStoredCurrentApp(app: App | null): void {
  window.localStorage.setItem(CURRENT_APP_STORAGE_KEY, JSON.stringify(app));
}
